/**
 * DevExtreme (esm/__internal/grids/new/grid_core/editing/confirm_controller.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    confirm
} from "../../../../../ui/dialog";
export class ConfirmController {
    confirm(message, title, showTitle) {
        return confirm(message, title, showTitle)
    }
}
ConfirmController.dependencies = [];
